<p-toast position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="PLANILHA DE ARRECADAÇÃO"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/money6.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 pt-2">
        <label style="font-weight: bold; color: #757575">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
    </div>
    <hr class="mt-1 mb-4" />

    <div class="row">
      <div class="col-md">
        <table class="table table-eddy" style="font-size:11px">
          <thead>
            <tr>
              <th scope="col" class="text-left">Código</th>
              <th scope="col" class="text-left">Nome</th>
              <th scope="col" class="text-right">Janeiro</th>
              <th scope="col" class="text-right">Fevereiro</th>
              <th scope="col" class="text-right">Março</th>
              <th scope="col" class="text-right">Abril</th>
              <th scope="col" class="text-right">Maio</th>
              <th scope="col" class="text-right">Junho</th>
              <th scope="col" class="text-right">Julho</th>
              <th scope="col" class="text-right">Agosto</th>
              <th scope="col" class="text-right">Setembro</th>
              <th scope="col" class="text-right">Outubro</th>
              <th scope="col" class="text-right">Novembro</th>
              <th scope="col" class="text-right">Dezembro</th>
              <th scope="col" class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaPlanilha">
              <th scope="col" class="text-left">{{item.r_codigo}}</th>
              <td class="text-left">{{item.r_nome}}</td>
              <td class="text-right">{{item.arrecadado_jan | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_fev | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_mar | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_abr | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_mai | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_jun | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_jul | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_ago | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_set | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_out | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_nov | number:'1.2-2'}}</td>
              <td class="text-right">{{item.arrecadado_dez | number:'1.2-2'}}</td>
              <td class="text-right">
                {{+item.arrecadado_jan + +item.arrecadado_fev + +item.arrecadado_mar + +item.arrecadado_abr + +item.arrecadado_mai + +item.arrecadado_jun + +item.arrecadado_jul + +item.arrecadado_ago + +item.arrecadado_set + +item.arrecadado_out + +item.arrecadado_nov + +item.arrecadado_dez | number:'1.2-2'}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="listaPlanilha && listaPlanilha.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>
